import _ from "lodash";
import {
    ChordContainer,
    HorizontalNoteContainer,
} from "../model/containers";

import {
    Chord,
    Note,
    NoteDuration,
    Tone,
    MetronomeMarking,
    TimeSignature,
    ToneIndex
} from "../model/core";
import {
    ComputedContextFrame,
} from "../model/context";

import COURANTE from "./courante";
import MAZURKA_CHORO from "./mazurka-choro";
import {
    ContextCell,
    ContextPlane,
} from "../model/context";
import { RydProject } from "../model/project";

class DemoData {
    static majorTriads() : HorizontalNoteContainer {
        const hnc = new HorizontalNoteContainer({ length: 8});
        [
            { at: 0, notes: [57, 61, 64], duration: new NoteDuration(32) },
            { at: 1, notes: [59, 62, 66], duration: new NoteDuration(32) },
            { at: 2, notes: [61, 64, 68], duration: new NoteDuration(32) },
            { at: 3, notes: [62, 66, 69], duration: new NoteDuration(32) },
            { at: 4, notes: [64, 68, 71], duration: new NoteDuration(32) },
            { at: 5, notes: [66, 69, 73], duration: new NoteDuration(32) },
            { at: 6, notes: [68, 71, 74], duration: new NoteDuration(32) }
        ].forEach(({ at, notes, duration }) => {
            notes.forEach(note => hnc.put(at, {
                step: at,
                payload: Note.fromIndex(note),
                duration,
                velocity: 100
            }));
        });

        return hnc;
    }

    static empty(l: number) : HorizontalNoteContainer {
        return new HorizontalNoteContainer({ length: l});
    }

    static emptyChordContainer(l : number) : ChordContainer {
        return new ChordContainer({ length: l });
    }

    static courante(limit = 2000) : HorizontalNoteContainer {

        const hnc: HorizontalNoteContainer = new HorizontalNoteContainer({ length: limit});

        _.each(COURANTE, function (note, i) {
            if (note.length == 0) return;
            if (i > limit) return;
            const step = i / 2;
            hnc.put(step, {
                step,
                payload: Note.fromIndex(note[0].note),
                duration: NoteDuration.fromBackendValue(note[0].duration),
                velocity: 100
             });
        });

        return hnc;
    }

    static couranteRydProject() {
        const il : RydProject = RydProject.createForNewProject('Courante');
        il.contextFrame.computed = new ComputedContextFrame();
        il.contextFrame.computed.metronome = new MetronomeMarking(120, new NoteDuration(4));
        il.contextFrame.computed.timeSignature = new TimeSignature(3, 4);

        il.put(0, this.courante());

        return il;
    }

    static weihnachtsBaeckerei() : RydProject{

        function makeChord(payload: {
            root: { index: ToneIndex },
            family: string,
            tones: { index: ToneIndex }[]
        }): Chord {
            const c = new Chord(Tone.fromIndex(payload.root.index), payload.family);
            c.tones = payload.tones.map(t => Tone.fromIndex(t.index));
            return c;
        }

        const weihnachtsBaeckereiUnified = [
            {
                "resolution": {
                    "value": 4
                },
                "length": 64,
                "grid": [
                    [
                        {
                            "payload": {
                                "type": "concrete",
                                "root": {
                                    "index": 7
                                },
                                "family": "maj",
                                "tones": [
                                    {
                                        "index": 7
                                    },
                                    {
                                        "index": 11
                                    },
                                    {
                                        "index": 2
                                    }
                                ]
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    null,
                    null,
                    [
                        {
                            "payload": {
                                "type": "concrete",
                                "root": {
                                    "index": 2
                                },
                                "family": "maj",
                                "tones": [
                                    {
                                        "index": 2
                                    },
                                    {
                                        "index": 6
                                    },
                                    {
                                        "index": 9
                                    }
                                ]
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    null,
                    null,
                    [
                        {
                            "payload": {
                                "type": "concrete",
                                "root": {
                                    "index": 7
                                },
                                "family": "maj",
                                "tones": [
                                    {
                                        "index": 7
                                    },
                                    {
                                        "index": 11
                                    },
                                    {
                                        "index": 2
                                    }
                                ]
                            },
                            "duration": {
                                "value": 32
                            }
                        }
                    ],
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    [
                        {
                            "payload": {
                                "type": "concrete",
                                "root": {
                                    "index": 0
                                },
                                "family": "maj",
                                "tones": [
                                    {
                                        "index": 0
                                    },
                                    {
                                        "index": 4
                                    },
                                    {
                                        "index": 7
                                    }
                                ]
                            },
                            "duration": {
                                "value": 32
                            }
                        }
                    ],
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    [
                        {
                            "payload": {
                                "type": "concrete",
                                "root": {
                                    "index": 2
                                },
                                "family": "maj",
                                "tones": [
                                    {
                                        "index": 2
                                    },
                                    {
                                        "index": 6
                                    },
                                    {
                                        "index": 9
                                    }
                                ]
                            },
                            "duration": {
                                "value": 32
                            }
                        }
                    ],
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    [
                        {
                            "payload": {
                                "type": "concrete",
                                "root": {
                                    "index": 0
                                },
                                "family": "maj",
                                "tones": [
                                    {
                                        "index": 0
                                    },
                                    {
                                        "index": 4
                                    },
                                    {
                                        "index": 7
                                    }
                                ]
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    null,
                    null,
                    [
                        {
                            "payload": {
                                "type": "concrete",
                                "root": {
                                    "index": 7
                                },
                                "family": "maj",
                                "tones": [
                                    {
                                        "index": 7
                                    },
                                    {
                                        "index": 11
                                    },
                                    {
                                        "index": 2
                                    }
                                ]
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    null,
                    null,
                    [
                        {
                            "payload": {
                                "type": "concrete",
                                "root": {
                                    "index": 0
                                },
                                "family": "maj",
                                "tones": [
                                    {
                                        "index": 0
                                    },
                                    {
                                        "index": 4
                                    },
                                    {
                                        "index": 7
                                    }
                                ]
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    null,
                    null,
                    [
                        {
                            "payload": {
                                "type": "concrete",
                                "root": {
                                    "index": 7
                                },
                                "family": "maj",
                                "tones": [
                                    {
                                        "index": 7
                                    },
                                    {
                                        "index": 11
                                    },
                                    {
                                        "index": 2
                                    }
                                ]
                            },
                            "duration": {
                                "value": 48
                            }
                        }
                    ],
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    [
                        {
                            "payload": {
                                "type": "concrete",
                                "root": {
                                    "index": 2
                                },
                                "family": "maj",
                                "tones": [
                                    {
                                        "index": 2
                                    },
                                    {
                                        "index": 6
                                    },
                                    {
                                        "index": 9
                                    }
                                ]
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    null,
                    null,
                    [
                        {
                            "payload": {
                                "type": "concrete",
                                "root": {
                                    "index": 7
                                },
                                "family": "maj",
                                "tones": [
                                    {
                                        "index": 7
                                    },
                                    {
                                        "index": 11
                                    },
                                    {
                                        "index": 2
                                    }
                                ]
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ]
                ],
                "type": "chordGroup"
            },
            {
                "resolution": {
                    "value": 8
                },
                "length": 64,
                "grid": [
                    [
                        {
                            "payload": {
                                "index": 59
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 59
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 57
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 57
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 55
                            },
                            "duration": {
                                "value": 48
                            }
                        }
                    ],
                    null,
                    null,
                    null,
                    null,
                    null,
                    [
                        {
                            "payload": {
                                "index": 57
                            },
                            "duration": {
                                "value": 8
                            }
                        }
                    ],
                    [
                        {
                            "payload": {
                                "index": 59
                            },
                            "duration": {
                                "value": 8
                            }
                        }
                    ],
                    [
                        {
                            "payload": {
                                "index": 60
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 60
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 59
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 59
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 57
                            },
                            "duration": {
                                "value": 48
                            }
                        }
                    ],
                    null,
                    null,
                    null,
                    null,
                    null,
                    [
                        {
                            "payload": {
                                "index": 57
                            },
                            "duration": {
                                "value": 8
                            }
                        }
                    ],
                    [
                        {
                            "payload": {
                                "index": 59
                            },
                            "duration": {
                                "value": 8
                            }
                        }
                    ],
                    [
                        {
                            "payload": {
                                "index": 60
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 60
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 62
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 57
                            },
                            "duration": {
                                "value": 8
                            }
                        }
                    ],
                    [
                        {
                            "payload": {
                                "index": 59
                            },
                            "duration": {
                                "value": 8
                            }
                        }
                    ],
                    [
                        {
                            "payload": {
                                "index": 60
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 60
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 62
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 62
                            },
                            "duration": {
                                "value": 8
                            }
                        }
                    ],
                    [
                        {
                            "payload": {
                                "index": 60
                            },
                            "duration": {
                                "value": 8
                            }
                        }
                    ],
                    [
                        {
                            "payload": {
                                "index": 59
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 59
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 62
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 62
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 57
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 57
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 62
                            },
                            "duration": {
                                "value": 16
                            }
                        }
                    ],
                    null,
                    [
                        {
                            "payload": {
                                "index": 62
                            },
                            "duration": {
                                "value": 8
                            }
                        }
                    ],
                    [
                        {
                            "payload": {
                                "index": 60
                            },
                            "duration": {
                                "value": 8
                            }
                        }
                    ]
                ],
                "type": "noteGroup"
            }
        ];
        const chords : ChordContainer = new ChordContainer({ length: 64 });
        const notes : HorizontalNoteContainer = new HorizontalNoteContainer({ length: 64 });

        weihnachtsBaeckereiUnified[0].grid.forEach((chord, i) => {
            if (!chord || chord.length == 0) return;
            chords.put(i, {
                step: i,
                payload: makeChord(chord[0].payload),
                duration: new NoteDuration(chord[0].duration.value),
                velocity: 100
            });
        });

        weihnachtsBaeckereiUnified[1].grid.forEach((ngs, i) => {
            if (!ngs || ngs.length == 0) return;
            ngs.forEach((ng, j) => {
                notes.put(i, {
                    step: i,
                    payload: Note.fromIndex(ng.payload.index),
                    duration: new NoteDuration(ng.duration.value),
                    velocity: 100
                });
            });
        });

        const il : RydProject = RydProject.createForNewProject('In der Weihnachts Bäckerei');
        il.contextFrame.computed = new ComputedContextFrame();
        il.contextFrame.computed.metronome = new MetronomeMarking(120, new NoteDuration(4));
        il.contextFrame.computed.timeSignature = new TimeSignature(4, 4);
        il.put(0, chords);
        il.put(1, notes);
        il.uiState = {
            tracks: new Map(),
            zoomFactor: 1,
            gridResolution: 'bar',
            snapToGrid: true,
            newNoteDuration: NoteDuration.fromBackendValue('QUARTER'),
            editMode: 'NOTES',
            globalKeybindingsSuspended: false,
        }
        il.mixerState = {
            tracks: new Map(),
            master: {
                gain: 1.0,
            }
        }

        return il;
    }

    static mazurkaChoro() : HorizontalNoteContainer {
        const hnc: HorizontalNoteContainer = new HorizontalNoteContainer({ length: MAZURKA_CHORO.lines[0].length });

        _.each(MAZURKA_CHORO.lines[0].grid, function (note, i) {
            if (note.length == 0) return;

            note.forEach((n, j) => {
                const step = Number.parseInt(i);
                hnc.put(step, {
                    step,
                    payload: Note.fromIndex(n.payload),
                    duration: new NoteDuration(n.duration.value * 2),
                    velocity: n.velocity
                });
            });
        });

        return hnc;
    }

    static mazurkaChoroRydProject() : RydProject {
        const mazurka = this.mazurkaChoro();
        const il : RydProject = RydProject.createForNewProject('Mazurka Choro');
        il.contextFrame.computed = new ComputedContextFrame();
        il.contextFrame.computed.metronome = new MetronomeMarking(MAZURKA_CHORO.contextFrame.metronome.bpm, NoteDuration.fromTimeSignature(MAZURKA_CHORO.contextFrame.metronome.beatDuration.value));
        il.contextFrame.computed.timeSignature = new TimeSignature(3, 4);

        il.put(0, mazurka);

        return il;
    }

    static lipsum(nWords: number) : string {
        /** returns n words of "ipsum loren" text. */
        var words = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam. Maecenas ligula massa, varius a, semper congue, euismod non, mi. Proin porttitor, orci nec nonummy molestie, enim est eleifend mi, non fermentum diam nisl sit amet erat. Duis semper. Duis arcu massa, scelerisque vitae, consequat in, pretium a, enim. Pellentesque congue. Ut in risus volutpat libero pharetra tempor. Cras vestibulum bibendum augue. Praesent egestas leo in pede. Praesent blandit odio eu enim.";
        return _(words.split(" ")).take(nWords).join(" ");
    }

    static harmonicFieldChordLine() : ChordContainer {
        const cc = new ChordContainer({ length: 32 });
        const chords = [
            new Chord("C", "maj"),
            new Chord("D", "min"),
            new Chord("E", "min"),
            new Chord("F", "maj"),
            new Chord("G", "maj"),
            new Chord("A", "min"),
            new Chord("B", "dim")
        ];
        chords[0].tones = ['C', 'E', 'G'].map(Tone.fromName);
        chords[1].tones = ['D', 'F', 'A'].map(Tone.fromName);
        chords[2].tones = ['E', 'G', 'B'].map(Tone.fromName);
        chords[3].tones = ['F', 'A', 'C'].map(Tone.fromName);
        chords[4].tones = ['G', 'B', 'D'].map(Tone.fromName);
        chords[5].tones = ['A', 'C', 'E'].map(Tone.fromName);
        chords[6].tones = ['B', 'D', 'F'].map(Tone.fromName);

        chords.forEach((c, i) => {
            const step = i * 4;
            cc.put(step, {
                step,
                payload: c,
                duration: NoteDuration.fromBackendValue("WHOLE"),
                velocity: 100
            });
        });
        return cc;
    }

    static circleOfFifths() : ContextPlane {
        const cp = new ContextPlane(24, 12);

        for (let i = 1; i < 12; i++) {
            cp.addCellToRow(i, new ContextCell(i * 2, 24 - (i * 2)));
        }
        return cp;
    }

}

export default DemoData;